import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../api";

export interface ThemeColors {
    top_bar_background?: string;
    button_primary?: string;
    button_secondary?: string;
    button_color?: string;
    primary_background?: string;
    primary_color?: string;
    correct_background?: string;
    correct_color?: string;
    incorrect_background?: string;
    incorrect_color?: string;
}

export type ProfileState = {
    loaded: boolean
    error: string | null
    full_name: string
    user_id: string
    permissions: string[]
    is_superuser: boolean
    defaultColors: ThemeColors;
    logo: string;
};

const initialState: ProfileState = {
    loaded: false,
    error: null,
    full_name: '',
    user_id: '',
    permissions: [],
    is_superuser: false,
    defaultColors: {},
    logo: ''
};

export const getProfile = createAsyncThunk(
    'profile/getProfile',
    async (_, thunkAPI) => {
        try {
            return await api.get('/API/profile/');
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const slice = createSlice({
    name: 'profile',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getProfile.pending, (state) => {
            state.loaded = false;
            state.error = null;
        });
        builder.addCase(getProfile.fulfilled, (state, action) => {
            state.loaded = true;
            state.error = null;
            state.full_name = action.payload.full_name;
            state.permissions = action.payload.permissions;
            state.user_id = action.payload.user_id;
            state.is_superuser = action.payload.is_superuser;
            if (action.payload.colors) {
                state.defaultColors = action.payload.colors;
            }
            if (action.payload.logo) {
                state.logo = action.payload.logo;
            }
        });
        builder.addCase(getProfile.rejected, (state, action) => {
            state.loaded = true;
            if (typeof action.payload === 'string') {
                state.error = action.payload as string;
            } else if (typeof action.error?.message === 'string') {
                state.error = action.error.message;
            }
        });
    }
});

export default slice.reducer;